module.exports = "https://web-assets.ifttt.com/packs/media/platform/Share_icon-8c667d65.svg";